document.addEventListener('DOMContentLoaded', function() {
  const wrapper = document.getElementById('koji-header-wrapper');
  const pullArea = document.getElementById('koji-integrated-pull');
  
  const headerInner = document.getElementById('koji-header-inner');
  
  function closeHeaderOnOutsideClick(e) {
    if (window.innerWidth < 990 && wrapper && wrapper.classList.contains('is-expanded')) {
      if (headerInner && !headerInner.contains(e.target)) {
        e.preventDefault();
        e.stopPropagation();
        
        wrapper.classList.remove('is-expanded', 'is-profile-open', 'is-cart-open', 'is-logo-open', 'is-manga-mobile-open');
        document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
        
        const mainNav = document.getElementById('koji-main-nav');
        const navWrapper = document.getElementById('koji-mobile-nav-wrapper');
        if (navWrapper && mainNav) {
            navWrapper.style.height = mainNav.offsetHeight + 'px';
        }
      }
    }
  }

  document.addEventListener('touchstart', closeHeaderOnOutsideClick, { capture: true, passive: false });

  const popupTriggers = document.querySelectorAll('.koji-popup-trigger');
  const mainNav = document.getElementById('koji-main-nav');
  const backBtns = document.querySelectorAll('.koji-nav-back-btn');
  const closeBtnsDesktop = document.querySelectorAll('.koji-manga-close');
  const navWrapper = document.getElementById('koji-mobile-nav-wrapper');

  function setNavHeight(activeElement) {
    if (navWrapper && activeElement && window.innerWidth < 990) {
      navWrapper.style.height = activeElement.offsetHeight + 'px';
    } else if (navWrapper) {
      navWrapper.style.height = 'auto'; 
    }
  }

  if (window.innerWidth < 990) {
    setTimeout(() => setNavHeight(mainNav), 50); 
  }

  popupTriggers.forEach(trigger => {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const targetId = this.getAttribute('data-target');
      
      document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));

      if (window.innerWidth < 990) {
        document.querySelectorAll('.koji-nav-subcategories').forEach(nav => nav.classList.remove('is-active'));
        const targetNav = document.getElementById('mobile-nav-' + targetId);
        if (targetNav) {
          targetNav.classList.add('is-active');
          wrapper.classList.add('is-manga-mobile-open');
          setNavHeight(targetNav);
          this.setAttribute('aria-expanded', 'true');
        }
      } else {
        wrapper.classList.remove('is-profile-open', 'is-cart-open', 'is-logo-open');
        const targetModal = document.getElementById('desktop-modal-' + targetId);
        
        if (targetModal && targetModal.classList.contains('is-active')) {
          targetModal.classList.remove('is-active');
          wrapper.classList.remove('is-manga-open');
        } else {
          document.querySelectorAll('.koji-popup-modal').forEach(m => m.classList.remove('is-active'));
          if (targetModal) {
            targetModal.classList.add('is-active');
            wrapper.classList.add('is-manga-open');
            this.setAttribute('aria-expanded', 'true');
          }
        }
      }
    });
  });

  backBtns.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      wrapper.classList.remove('is-manga-mobile-open');
      document.querySelectorAll('.koji-nav-subcategories').forEach(nav => nav.classList.remove('is-active'));
      document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
      setNavHeight(mainNav); 
    });
  });

  closeBtnsDesktop.forEach(btn => {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      wrapper.classList.remove('is-manga-open');
      document.querySelectorAll('.koji-popup-modal').forEach(m => m.classList.remove('is-active'));
      document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
    });
  });

  if (wrapper && window.innerWidth < 990) {
    let touchStartX = 0;
    let touchStartY = 0;

    wrapper.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    wrapper.addEventListener('touchmove', function(e) {
      const scrollableArea = e.target.closest('.koji-cart-items-new, .koji-nav-list, .koji-sub-list, .koji-mobile-funfacts, .koji-desktop-manga-grid, .koji-essence-track, .koji-profile-modal');
      
      if (scrollableArea) {
        const isHorizontal = scrollableArea.classList.contains('koji-nav-list') || scrollableArea.classList.contains('koji-sub-list') || scrollableArea.classList.contains('koji-essence-track');
        
        if (isHorizontal) {
          const currentX = e.touches[0].clientX;
          const currentY = e.touches[0].clientY;
          const diffX = Math.abs(currentX - touchStartX);
          const diffY = Math.abs(currentY - touchStartY);

          if (diffX > diffY) {
            e.stopPropagation();
          } else {
            e.preventDefault();
          }
          return;
        }

        const currentY = e.touches[0].clientY;
        const deltaY = currentY - touchStartY;
        
        const isAtTop = scrollableArea.scrollTop <= 0;
        const isAtBottom = scrollableArea.scrollHeight - scrollableArea.scrollTop <= scrollableArea.clientHeight + 1;
        
        if ((isAtTop && deltaY > 0) || (isAtBottom && deltaY < 0)) {
           e.preventDefault(); 
        }
        e.stopPropagation();
      } else {
        if (!e.target.closest('#koji-integrated-pull, a, button, .koji-icon-btn, .koji-quick-btn')) {
          e.preventDefault();
        }
      }
    }, { passive: false });
  }

  const funfactsContainer = document.getElementById('koji-funfacts-data');
  const interactiveFacts = document.querySelectorAll('.koji-interactive-fact');
  const desktopFunfactTrigger = document.getElementById('koji-funfact-trigger'); 
  
  let factsArray = [];
  let lastFact = "";

  if (funfactsContainer) {
    const factItems = funfactsContainer.querySelectorAll('.koji-fact-item');
    factItems.forEach(item => factsArray.push(item.textContent));
  }

  function getRandomFact() {
    if (factsArray.length === 0) return "Nessuna informazione rilevata nel grimorio.";
    if (factsArray.length === 1) return factsArray[0];

    let newFact;
    do {
      newFact = factsArray[Math.floor(Math.random() * factsArray.length)];
    } while (newFact === lastFact);
    
    lastFact = newFact;
    return newFact;
  }

  interactiveFacts.forEach(factEl => {
    factEl.textContent = getRandomFact();
  });

  interactiveFacts.forEach(factEl => {
    factEl.addEventListener('click', function(e) {
      e.stopPropagation(); 
      this.classList.add('koji-fact-pop-out');
      
      setTimeout(() => {
        this.textContent = getRandomFact();
        this.classList.remove('koji-fact-pop-out');
        this.classList.add('koji-fact-pop-in');
        
        setTimeout(() => {
          this.classList.remove('koji-fact-pop-in');
        }, 200);
      }, 200);
    });
  });

  if (desktopFunfactTrigger) {
    desktopFunfactTrigger.addEventListener('click', function(e) {
      if (window.innerWidth >= 990) {
        e.preventDefault(); 
        e.stopPropagation(); 
        wrapper.classList.remove('is-expanded', 'is-profile-open', 'is-cart-open', 'is-manga-open');
        document.querySelectorAll('.koji-popup-modal').forEach(m => m.classList.remove('is-active'));
        document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
        
        wrapper.classList.toggle('is-logo-open'); 
        if (wrapper.classList.contains('is-logo-open')) {
          const deskText = document.getElementById('koji-desktop-funfact-text');
          if(deskText) {
            deskText.classList.remove('koji-fact-pop-out', 'koji-fact-pop-in');
            deskText.textContent = getRandomFact();
          }
        }
      }
    });
  }

  if (pullArea && wrapper) {
    let startY = 0, currentY = 0, isSwipingHeader = false, initialHeight = 0;
    const expandedContent = document.getElementById('koji-expanded-content');
    const maxHeaderHeight = 450; 

    pullArea.addEventListener('touchstart', function(e) {
      startY = e.touches[0].clientY;
      currentY = startY;
      isSwipingHeader = false;
      wrapper.classList.add('is-pressed');
      expandedContent.style.transition = 'none'; 
      initialHeight = wrapper.classList.contains('is-expanded') ? expandedContent.scrollHeight : 0;
      e.preventDefault(); 
    }, { passive: false });

    pullArea.addEventListener('touchmove', function(e) {
      currentY = e.touches[0].clientY;
      const distanceY = startY - currentY; 
      
      if (Math.abs(distanceY) > 2) {
        isSwipingHeader = true;
        let newHeight = initialHeight + distanceY;
        if (newHeight < 0) newHeight = 0;
        if (newHeight > maxHeaderHeight) newHeight = maxHeaderHeight + (newHeight - maxHeaderHeight) * 0.1; 
        expandedContent.style.maxHeight = `${newHeight}px`;
        let opacity = newHeight / 200; 
        expandedContent.style.opacity = Math.min(opacity, 1);
      }
      e.preventDefault(); e.stopPropagation();
    }, { passive: false });

    pullArea.addEventListener('touchend', function(e) {
      wrapper.classList.remove('is-pressed');
      expandedContent.style.transition = 'max-height 0.25s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.2s ease, visibility 0.2s ease';
      
      const distanceY = startY - currentY;
      const threshold = 30; 
      
      if (Math.abs(distanceY) < 10) {
        wrapper.classList.toggle('is-expanded');
        wrapper.classList.remove('is-profile-open', 'is-cart-open', 'is-logo-open', 'is-manga-mobile-open');
        document.querySelectorAll('.koji-nav-subcategories').forEach(nav => nav.classList.remove('is-active'));
        if (wrapper.classList.contains('is-expanded')) {
          if (window.innerWidth < 990) setNavHeight(mainNav);
        }
      } 
      else if (isSwipingHeader) {
        if (distanceY > threshold && !wrapper.classList.contains('is-expanded')) {
          wrapper.classList.add('is-expanded');
          wrapper.classList.remove('is-profile-open', 'is-cart-open', 'is-logo-open', 'is-manga-mobile-open');
          document.querySelectorAll('.koji-nav-subcategories').forEach(nav => nav.classList.remove('is-active'));
          if (window.innerWidth < 990) setNavHeight(mainNav);
        } else if (distanceY < -threshold && wrapper.classList.contains('is-expanded')) {
          wrapper.classList.remove('is-expanded');
        }
      }
      
      expandedContent.style.maxHeight = '';
      expandedContent.style.opacity = '';
      
      setTimeout(() => { 
        isSwipingHeader = false; 
        expandedContent.style.transition = ''; 
      }, 250);
    }, { passive: false });

    pullArea.addEventListener('touchcancel', function() { 
      wrapper.classList.remove('is-pressed'); 
      expandedContent.style.transition = '';
      expandedContent.style.maxHeight = '';
      expandedContent.style.opacity = '';
      isSwipingHeader = false;
    }, { passive: true });
  }

  function setKojiReactions() {
    const filledReactionEl = document.getElementById('koji-cart-reaction-text');
    const filledReactionsData = document.getElementById('koji-reactions-data');
    if (filledReactionEl && filledReactionsData) {
      const reactions = filledReactionsData.textContent.split('|').map(s => s.trim()).filter(s => s);
      if (reactions.length > 0) {
        const randomReaction = reactions[Math.floor(Math.random() * reactions.length)];
        filledReactionEl.innerHTML = randomReaction; 
      }
    }

    const emptyReactionEl = document.getElementById('koji-cart-empty-reaction-text');
    const emptyReactionsData = document.getElementById('koji-empty-reactions-data');
    if (emptyReactionEl && emptyReactionsData) {
      const emptyReactions = emptyReactionsData.textContent.split('|').map(s => s.trim()).filter(s => s);
      if (emptyReactions.length > 0) {
        const randomEmptyReaction = emptyReactions[Math.floor(Math.random() * emptyReactions.length)];
        emptyReactionEl.innerHTML = randomEmptyReaction;
      }
    }
  }

  const profileTriggers = document.querySelectorAll('#koji-profile-trigger, .koji-btn-profile');
  const cartTriggers = document.querySelectorAll('#koji-cart-trigger, .koji-btn-cart');

  profileTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault(); 
      e.stopPropagation();
      e.stopImmediatePropagation();
      wrapper.classList.remove('is-expanded', 'is-cart-open', 'is-logo-open', 'is-manga-open', 'is-manga-mobile-open'); 
      document.querySelectorAll('.koji-popup-modal').forEach(m => m.classList.remove('is-active'));
      document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
      wrapper.classList.toggle('is-profile-open');
    }, { capture: true });
  });

  cartTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault(); 
      e.stopPropagation();
      e.stopImmediatePropagation();
      wrapper.classList.remove('is-expanded', 'is-profile-open', 'is-logo-open', 'is-manga-open', 'is-manga-mobile-open'); 
      document.querySelectorAll('.koji-popup-modal').forEach(m => m.classList.remove('is-active'));
      document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
      wrapper.classList.toggle('is-cart-open');
      if (wrapper.classList.contains('is-cart-open')) {
        setKojiReactions(); 
      }
    }, { capture: true });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('#koji-profile-close')) { e.preventDefault(); wrapper.classList.remove('is-profile-open'); return; }
    if (e.target.closest('#koji-cart-close')) { e.preventDefault(); wrapper.classList.remove('is-cart-open'); return; }

    if (wrapper && wrapper.classList.contains('is-profile-open') && !document.getElementById('koji-profile-modal').contains(e.target)) {
      wrapper.classList.remove('is-profile-open'); 
    }
    if (wrapper && wrapper.classList.contains('is-cart-open')) {
      const currentCartModal = document.getElementById('koji-cart-modal');
      if (currentCartModal && !currentCartModal.contains(e.target)) {
        wrapper.classList.remove('is-cart-open'); 
      }
    }
    if (wrapper && wrapper.classList.contains('is-logo-open') && !document.getElementById('koji-desktop-funfacts-bubble').contains(e.target)) {
      wrapper.classList.remove('is-logo-open');
    }
    if (wrapper && wrapper.classList.contains('is-manga-open')) {
      let isInside = false;
      document.querySelectorAll('.koji-popup-modal.is-active').forEach(m => {
        if (m.contains(e.target)) isInside = true;
      });
      let isTrigger = false;
      document.querySelectorAll('.koji-popup-trigger').forEach(t => {
        if (t.contains(e.target)) isTrigger = true;
      });

      if (!isInside && !isTrigger && !e.target.closest('.koji-manga-close')) {
        wrapper.classList.remove('is-manga-open');
        document.querySelectorAll('.koji-popup-modal').forEach(m => m.classList.remove('is-active'));
        document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
      }
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && wrapper) {
      wrapper.classList.remove('is-profile-open', 'is-cart-open', 'is-logo-open', 'is-manga-open', 'is-manga-mobile-open');
      document.querySelectorAll('.koji-popup-modal').forEach(m => m.classList.remove('is-active'));
      document.querySelectorAll('.koji-popup-trigger').forEach(t => t.setAttribute('aria-expanded', 'false'));
    }
  });

  function updateCartUI() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartBadge = document.getElementById('koji-cart-badge');
        if (cartBadge) {
          cartBadge.textContent = cart.item_count;
          if (cart.item_count > 0) { cartBadge.classList.add('is-active'); } else { cartBadge.classList.remove('is-active'); }
        }
      });

    const headerSection = wrapper.closest('.shopify-section');
    if (!headerSection) return;
    const sectionId = headerSection.id.replace('shopify-section-', '');

    fetch(`/?section_id=${sectionId}`)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const newCartModal = html.querySelector('#koji-cart-modal');
        const oldCartModal = document.getElementById('koji-cart-modal');
        if (newCartModal && oldCartModal) {
          oldCartModal.innerHTML = newCartModal.innerHTML;
          attachCartRemoveListeners(oldCartModal);
          setKojiReactions(); 
        }
      });
  }

  const originalFetch = window.fetch;
  window.fetch = function() {
      return originalFetch.apply(this, arguments).then(function(res) {
          const url = res.url;
          if (res.ok && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
              updateCartUI();
          }
          return res;
      });
  };

  window.addEventListener('cart:updated', function() { updateCartUI(); });

  function attachCartRemoveListeners(container) {
    const removeLinks = container.querySelectorAll('a[href*="/cart/change?line="]');
    removeLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault(); 
        fetch(this.getAttribute('href'), { method: 'GET' }).then(response => { if (response.ok) updateCartUI(); });
      });
    });
  }

  const initialCartModal = document.getElementById('koji-cart-modal');
  if (initialCartModal) {
    attachCartRemoveListeners(initialCartModal);
    setKojiReactions(); 
  }

  if (window.location.pathname.includes('/cart')) {
      const cartContainer = document.querySelector('form.cart, .cart-wrapper, cart-items');
      if (cartContainer) {
          const observer = new MutationObserver(function() { updateCartUI(); });
          observer.observe(cartContainer, { childList: true, subtree: true });
      }
  }
});

(function() {
  const initPageTransition = () => {
    document.body.classList.add('koji-is-loaded');
  };

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initPageTransition();
  } else {
    window.addEventListener('DOMContentLoaded', initPageTransition);
  }

  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    
    if (!link || e.defaultPrevented) return;
    if (link.closest('#koji-profile-trigger, #koji-cart-trigger, #koji-logo-trigger, .koji-popup-trigger, .koji-funfact-trigger, .koji-btn-profile, .koji-btn-cart, .koji-back-btn, .koji-mobile-back-btn')) return;

    const href = link.getAttribute('href');

    /* Guardia di sicurezza per evitare TypeErrors su link senza href o ancore disattivate */
    if (
      !href ||
      link.hostname !== window.location.hostname || 
      link.target === '_blank' || 
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href === '#' ||
      link.hasAttribute('download') ||
      e.metaKey || e.ctrlKey || e.shiftKey
    ) return;

    e.preventDefault();
    const targetUrl = link.href;

    document.body.classList.add('koji-is-leaving');

    setTimeout(() => {
      window.location.href = targetUrl;
    }, 200);
  });

  window.addEventListener('pageshow', function(event) {
    document.body.classList.remove('koji-is-leaving');
    document.body.classList.add('koji-is-loaded');
  });
})();